import React, { useState, useEffect, useRef, useCallback } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { addLocale } from "primereact/api";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import moment from "moment";
import { Tag } from "primereact/tag";
import { Badge } from "primereact/badge";
import { ProgressBar } from "primereact/progressbar";
import { getListaMatricula } from "../../service/Matricula";
import { useDispatch, useSelector } from "react-redux";
import { loading, setUsuarioLogin} from "../../actions";
import { DialogMatricula } from "../../components/DialogMatricula";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { deleteMatricula, deleteMatriculaMasivo } from "../../service/Matricula";
import { FiltroNivelCurso } from "../../components/FiltroNivelCurso";
import { useHistory } from "react-router-dom";
import { accionPermiso } from "../../utilities/Seguridad";

export const PageMatricula = () => {
    const dispatch = useDispatch();

    let ColegioData = {
        id: null,
        idmatricula: null,
        idalumno: null,
        fecha_matricula: "",
        rbd: "",
        colegio: "",
        grado: "",
        run: "",
        digito_verificador: "",
        nombres: "",
        apellido_paterno: "",
        apellido_materno: "",
        diagnostico: "",
        tipo_nee: "",
        observacion: "",
        adicional: "",
    };

    const [dataTable, setDataTable] = useState(ColegioData);
    const [dataTableFilter, setDataTableFilter] = useState(ColegioData);
    const [globalFilter, setGlobalFilter] = useState("");

    const [visibleDialogMatricula, setVisibleDialogMatricula] = useState(false);
    const [selectMatriculados, setSelectMatriculados] = useState(null);
    const [countDelete, setCountDelete] = useState(0);

    const toast = useRef(null);

    // Reset Filtros Curso y grado
    const filtroRef = useRef(null);

    // Permisos
    const history = useHistory();
    const permisos = useRef({ superusuario: false, acciones: [] });
    const { usuario, colegio, anio } = useSelector((state) => ({
        usuario: state.usuario,
        colegio: state.colegio,
        anio: state.anio,
    }));

    try {
        permisos.current.superusuario = usuario.superusuario;
        permisos.current.acciones = usuario.permisos.registros.matricula_pie.acciones;
    } catch (error) {
        permisos.current.acciones = [];
    }
    //----------------------------

    useEffect(() => {
        if (accionPermiso(permisos, "mat_pie_ver")) {
            loadListaMatricula();
        } else {
            history.push("/Acceso");
        }
    }, [anio]);

    const getFiltroNivelCurso = useCallback(
        (data) => {
            if (data.es_nivel) {
                if (data.idnivel == 0) {
                    setDataTableFilter(dataTable);
                } else {
                    setDataTableFilter(dataTable.filter((o) => o.idnivel == data.idnivel));
                }
            } else {
                if (data.id == 0) {
                    setDataTableFilter(dataTable.filter((o) => o.idnivel == data.idnivel));
                } else {
                    setDataTableFilter(dataTable.filter((o) => o.idgrado== data.id &&
                     o.idnivel == data.idnivel));
                }
            }
        },
        [dataTableFilter]
    )

    const loadListaMatricula = async () => {
        if (colegio.id !== undefined && anio.anio !== undefined) {
            dispatch(loading(true));
            filtroRef.current.click();
            var data = await getListaMatricula(colegio.id, anio.anio, usuario.token);
            if (data.error == 0) {
                dispatch(loading(true));

                setDataTable(data.matricula_pie);
                setDataTableFilter(data.matricula_pie);
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }

            dispatch(loading(false));
        } else {
            setDataTable([]);
            setDataTableFilter([]);
        }
        setCountDelete(0);
        setSelectMatriculados(null);
    };

    const bodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field]}
            </>
        );
    };

    const bodyTemplateDate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field] === null ? "--" : moment(data[props.field]).format("DD/MM/YYYY")}
            </>
        );
    };

    const exportExcel = () => {
        let dataExportar = [];
        dataTableFilter?.map((obj) => {
            let o = { ...obj };
            delete o.id;
            delete o.idmatricula;
            delete o.idalumno;
            delete o.digito_verificador;
            delete o.iddiagnostico;
            delete o.idtipo_nee;
            delete o.formulario_fudei;
            delete o.formulario_reevaluacion;
            dataExportar.push(o);
        });

        import("xlsx").then((xlsx) => {
            const worksheet = xlsx.utils.json_to_sheet(dataExportar);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer = xlsx.write(workbook, { bookType: "xlsx", type: "array" });
            saveAsExcelFile(excelBuffer, "Matriculas");
        });
    };

    const saveAsExcelFile = (buffer, fileName) => {
        import("file-saver").then((FileSaver) => {
            let EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            let EXCEL_EXTENSION = ".xlsx";
            const data = new Blob([buffer], {
                type: EXCEL_TYPE,
            });
            FileSaver.saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
        });
    };



    const dataTableHeader = (
        <div className="p-formgrid p-grid p-col-12 p-fluid p-p-0">
            <div className="p-col-12 p-md-6 p-lg-2 p-mt-5">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} className="p-mr-3" placeholder="Buscar..." />
                </span>
            </div>
            <div className="p-col-12 p-md-6 p-lg-3">{accionPermiso(permisos, "mat_pie_ver") ? <FiltroNivelCurso getFiltroNivelCurso={getFiltroNivelCurso} reset={filtroRef} /> : ""}</div>
            <div className="p-col-8 p-md-2 p-lg-3 p-offset-4 p-mt-3" style={{ textAlign: "right" }}>
                {accionPermiso(permisos, "mat_pie_eliminar_masivo") && countDelete > 0 ? (
                    <i className="pi pi-trash mr-4 p-text-secondary p-overlay-badge" style={{ fontSize: "2rem", marginRight: "1.5rem", cursor: "pointer" }} onClick={() => confirmDeleteMasivo(null)}>
                        <Badge value={countDelete} severity="danger"></Badge>
                    </i>
                ) : (
                    ""
                )}
                {accionPermiso(permisos, "mat_pie_exportar") ? <Button type="button" icon="pi pi-file-excel" onClick={exportExcel} className="p-button-success mr-2 p-mr-1" tooltip="Descargar" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }} /> : ""}
                <Button type="button" icon="pi pi-refresh" className="mr-2" onClick={loadListaMatricula} tooltip="Actualizar" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}></Button>
                
            </div>
        </div>
    );

    const statusBodyTemplate = (rowData) => {
        if (rowData.adicional === 1) {
            return <Tag className="mr-2" severity="info" value="ADICIONAL"></Tag>;
        }
    };

    const data = useRef(null);
    const tipo = useRef(null);

    const viewDetalle = (row) => {
        data.current = row;
        tipo.current = false;
        setVisibleDialogMatricula(true);
    };

    const handleClose = useCallback(
        (save) => {
            setVisibleDialogMatricula(false);
            if (save) loadListaMatricula();
        },
        [visibleDialogMatricula]
    );

    const idMatri = useRef(null);

    const accept = async () => {
        let data = await deleteMatricula(idMatri.current, usuario.token);
        if (data.error == 0) {
            toast.current.show({ severity: "success", summary: "OK", detail: "Se eliminó la Matricula", life: 3000 });
            loadListaMatricula();
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }
    };

    const eliminarMasivo = async () => {
        let arrayIds = selectMatriculados.map(function (item) {
            return item.id;
        });

        dispatch(loading(true));
        let data = await deleteMatriculaMasivo(colegio.id, anio.anio, arrayIds, usuario.token);
        if (data.error == 0) {
            toast.current.show({ severity: "success", summary: "OK", detail: "Se eliminaron los registros", life: 3000 });
            loadListaMatricula();
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }
        dispatch(loading(false));
    };

    const confirmDelete = (row) => {
        idMatri.current = row.id;
        confirmDialog({
            message: "Estas seguro de eliminar el registro?",
            header: "Eliminar Confirmar",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept,
        });
    };

    const confirmDeleteMasivo = () => {
        confirmDialog({
            message: "Estas seguro de eliminar el/los registros?",
            header: "Eliminar Confirmar",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: () => eliminarMasivo(),
        });
    };

    const actionHerramientas = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-info-circle" className="p-button-rounded p-button-help p-mr-2" tooltip={rowData.observacion} tooltipOptions={{ position: "bottom" }}></Button>
                {accionPermiso(permisos, "mat_pie_editar") ? <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-mr-2" onClick={() => viewDetalle(rowData)} /> : ""}
                {accionPermiso(permisos, "mat_pie_eliminar") && countDelete < 1 ? <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => confirmDelete(rowData)} /> : ""}
            </div>
        );
    };

    

    const checkMatricula = (value) => {
        if (!accionPermiso(permisos, "mat_pie_eliminar_masivo")) return true;
        setSelectMatriculados(value);
        setCountDelete(value.length);
    };

    const bodyTemplateActivo = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                <Tag className="p-mr-2" severity={data[props.field] == 1 ? "success" : "warning"} value={data[props.field] == 1 ? "ACTIVO" : "RETIRADO"}></Tag>
            </>
        )
    }
    

    return (
        <div className="p-grid table-demo">
            <div className="p-col-12">
                <Toast ref={toast} />

                <DataTable
                    value={dataTableFilter}
                    selectionMode="checkbox"
                    paginator
                    id="136"
                    className="p-datatable-customers p-datatable-sm"
                    rows={10}
                    dataKey="id"
                    selection={selectMatriculados}
                    onSelectionChange={(e) => checkMatricula(e.value)}
                    rowHover
                    globalFilter={globalFilter}
                    emptyMessage="No existe información!"
                    loading={false}
                    header={dataTableHeader}
                    metaKeySelection={true}
                    size="small"
                >
                    {/* <Column field="fecha_matricula" header="Fecha Matricula" sortable body={bodyTemplateDate} ></Column>*/}
                    {/*  <Column field="rbd" header="Rbd" sortable body={bodyTemplate} ></Column> */}
                    {accionPermiso(permisos, "mat_pie_eliminar_masivo") ? <Column selectionMode="multiple" headerStyle={{ width: "3em" }}></Column> : <Column headerStyle={{ width: "0" }}></Column>}
                    <Column field="cod_ensenanza" headerStyle={{ width: "3.5rem" }} bodyStyle={{ textAlign: "center"}} header="Código" body={bodyTemplate}></Column>
                    <Column field="grado" headerStyle={{ width: "4rem",textAlign: "center"  }} bodyStyle={{ textAlign: "center" }}  header="Curso" body={bodyTemplate}></Column>
                    <Column field="run" header="Run"  body={bodyTemplate}></Column>
                    <Column field="nombres" header="Nombres"  body={bodyTemplate}></Column>
                    <Column field="apellido_paterno" header="Paterno"  body={bodyTemplate}></Column>
                    <Column field="apellido_materno" header="Materno"  body={bodyTemplate}></Column>
                    <Column field="estado_alumno" headerStyle={{ width: "6rem" }} header="Estado" sortable body={bodyTemplateActivo}></Column>
                    {/* <Column field="tipo_nee" header="NEE" sortable body={bodyTemplate}></Column> */}
                    <Column headerStyle={{ width: "15rem", textAlign: "center" }} field="diagnostico" header="Diagnóstico" sortable body={bodyTemplate}></Column>

                    <Column field="adicional" header="Adicional"  body={statusBodyTemplate}></Column>
                    <Column header="Herramientas" headerStyle={{ width: "13rem", textAlign: "center" }} bodyStyle={{ textAlign: "center", overflow: "visible", justifyContent: "center" }} body={actionHerramientas}></Column>
                </DataTable>
                
                {accionPermiso(permisos, "mat_pie_ver") ? <DialogMatricula visible={visibleDialogMatricula} handleClose={handleClose} data={data.current} neww={tipo.current} /> : ""}
            </div>
        </div>
    );
};
